<template>
  <div>
    <b-container>
      <h2 class="mt-3 mb-5 text-center">
        <span v-if="this.lodash.get(this.$store.state.placeContext, 'workshop_parameters.front.title')">
          {{ this.$store.state.placeContext.workshop_parameters.front.title }}
        </span>
        <span v-else>
          {{ $t('home.workshops.title') }}
        </span>
      </h2>

      <b-row class="text-center my-5 d-flex align-items-center">
        <b-col cols="9" class="mx-auto"
          v-if="this.lodash.get(this.$store.state.placeContext, 'workshop_parameters.front.display_search')">
          <b-form-input v-model="search" type="search" :placeholder="$t('common.search')"></b-form-input>
        </b-col>
        <b-col cols="3" class="mx-auto text-right" v-if="'pc' === $route.query.ref">
          <b-link @click="backToPlacesChoice" class="text-muted">
            ← {{ $t('home.backToPlacesChoice') }}
          </b-link>
        </b-col>
      </b-row>

      <b-row align="center" class="mt-2" v-if="workshopCollectionLoading">
        <b-col cols="12" xl="4" lg="4" md="6" sm="6" xs="12"
          v-for="n in [1, 2, 3]" :key="n"
          class="mb-4">
          <b-card no-body img-top>
            <b-skeleton-img card-img="top" aspect="3:1"></b-skeleton-img>
            <b-card-body>
              <b-skeleton animation="wave" width="85%"></b-skeleton>
              <b-skeleton animation="wave" width="55%"></b-skeleton>
              <b-skeleton animation="wave" width="70%"></b-skeleton>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row align="center" class="mt-5" v-if="false === workshopCollectionLoading && 0 < availableWorkshops.length">
        <b-col cols="12" xl="4" lg="4" md="6" sm="6" xs="12"
          v-for="workshop in availableWorkshops" :key="workshop.uuid"
          class="mb-4">
          <WorkshopCards :workshop="workshop" />
        </b-col>
      </b-row>

      <div v-if="false === workshopCollectionLoading && 0 === workshops.length">
        <div v-if="this.lodash.get(this.$store.state.placeContext, 'workshop_parameters.front.no_workshop_found_html')"
          v-html="this.lodash.get(this.$store.state.placeContext, 'workshop_parameters.front.no_workshop_found_html')">
        </div>
        <div v-else>
          <b-alert variant="warning" show>
            {{ $t('home.workshops.alerts.noWorkshop') }}
          </b-alert>
        </div>
      </div>

      <b-alert variant="warning" show v-if="false === workshopCollectionLoading && 0 < workshops.length && 0 === availableWorkshops.length">
        {{ $t('home.workshops.alerts.noAvailableWorkshop') }}
      </b-alert>

      <div v-if="currentUser && 0 < currentUserWorkshops.length">
        <h2 class="my-5">{{ $t('home.userWorkshops.title') }}</h2>

        <b-row align="center" class="mt-5">
          <b-col cols="12" xl="4" lg="4" md="6" sm="6" xs="12"
            v-for="workshop in currentUserWorkshops"
            :key="workshop.uuid"
            class="mb-4">
            <WorkshopCards :workshop="workshop" :with-register="false" :with-cancel="true" />
          </b-col>
        </b-row>
      </div>
    </b-container>

    <b-modal id="participantFormModal" :title="$t('modals.participant.title')" :hide-footer="true">
      <b-form @submit.prevent.stop="login" ref="loginForm" v-if="currentWorkshop">
        <b-form-group :label="$t('modals.participant.form.email')" label-for="participant-form-email"
          class="required">
          <b-form-input id="participant-form-email" type="email" required
            :disabled="participantFormLoading"
            v-model="participantFormData.email"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('modals.participant.form.firstname')" label-for="participant-form-firstname"
          :class="{'required': currentWorkshop.mandatoryFields.includes('firstname')}"
          v-if="currentWorkshop.askedFields.includes('firstname')">
          <b-form-input id="participant-form-firstname" type="text"
            :required="currentWorkshop.mandatoryFields.includes('firstname')"
            :disabled="participantFormLoading"
            v-model="participantFormData.firstname"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('modals.participant.form.lastname')" label-for="participant-form-lastname"
          :class="{'required': currentWorkshop.mandatoryFields.includes('lastname')}"
          v-if="currentWorkshop.askedFields.includes('lastname')">
          <b-form-input id="participant-form-lastname" type="text"
            :required="currentWorkshop.mandatoryFields.includes('lastname')"
            :disabled="participantFormLoading"
            v-model="participantFormData.lastname"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('modals.participant.form.address')" label-for="participant-form-address"
          :class="{'required': currentWorkshop.mandatoryFields.includes('address')}"
          v-if="currentWorkshop.askedFields.includes('address')">
          <b-form-textarea id="participant-form-address" type="text"
            :required="currentWorkshop.mandatoryFields.includes('address')"
            :disabled="participantFormLoading"
            v-model="participantFormData.address"
          ></b-form-textarea>
        </b-form-group>

        <b-form-group :label="$t('modals.participant.form.phone')" label-for="participant-form-phone"
          :class="{'required': currentWorkshop.mandatoryFields.includes('phone')}"
          v-if="currentWorkshop.askedFields.includes('phone')">
          <b-form-input id="participant-form-phone" type="text"
            :required="currentWorkshop.mandatoryFields.includes('phone')"
            :disabled="participantFormLoading"
            v-model="participantFormData.phone"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('modals.participant.form.loyalty_card_number')" label-for="participant-form-loyalty-card-number"
          :class="{'required': currentWorkshop.mandatoryFields.includes('loyalty_card_number')}"
          v-if="currentWorkshop.askedFields.includes('loyalty_card_number')">
          <b-form-input id="participant-form-loyalty-card-number" type="text"
            :required="currentWorkshop.mandatoryFields.includes('loyalty_card_number')"
            :disabled="participantFormLoading"
            v-model="participantFormData.loyalty_card_number"
          ></b-form-input>
        </b-form-group>

        <div class="mt-3 pt-3 border-top text-right">
          <b-button type="submit" variant="primary" :disabled="participantFormLoading">
            {{ $t('modals.participant.submit') }}
            <b-icon icon="three-dots" animation="cylon"
              v-if="participantFormLoading"></b-icon>
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
  import { userEventBus } from './events/bus'
  import ApiService from './services/api'
  import debounce from "lodash.debounce";
  import WorkshopCards from './components/Workshops/Card'

  export default {
    components: {
      WorkshopCards,
    },

    mounted() {
      userEventBus.$on('user.logged', () => {
        ApiService.getCurrentUserWorkshops()
          .then(response => {
            this.$store.dispatch('setUserWorkshops', response.data)
          })
      })

      this.fetchWorkshops()
    },

    data() {
      return {
        workshopCollectionLoading: false,
        workshops: [],
        participantFormLoading: false,
        search: "",
        participantFormData: {
          firstname: '',
          lastname: '',
          email: '',
          address: '',
          phone: '',
          loyalty_card_number: '',
        },
        currentWorkshop: undefined,
      }
    },

    computed: {
      currentUser() {
        return this.$store.state.user
      },
      currentUserWorkshops() {
        return this.$store.state.userWorkshops
      },
      availableWorkshops() {
        const workshopsUuids = this.currentUserWorkshops.map(workshop => workshop.uuid)

        return this.workshops.filter(workshop => false === workshopsUuids.includes(workshop.uuid))
      }
    },

    methods: {
      fetchWorkshops: function () {
        this.workshopCollectionLoading = true
        ApiService.getWorkshops(this.search)
          .then(result => {
            this.workshops = result.data.filter(workshop => workshop.status === "published").map(workshop => {
              if (typeof workshop.askedFields === 'object') {
                workshop.askedFields = Object.values(workshop.askedFields)
              }
              if (typeof workshop.mandatoryFields === 'object') {
                workshop.mandatoryFields = Object.values(workshop.mandatoryFields)
              }

              return workshop
            })
          })
          .finally(() => this.workshopCollectionLoading = false)
      },

      login() {
        this.participantFormLoading = true

        ApiService.loginOrRegister({
          email: this.participantFormData.email,
          firstname: this.participantFormData.firstname,
          lastname: this.participantFormData.lastname,
          locale: this.$i18n.locale.substring(0, 2),
          address: this.participantFormData.address,
          phone: this.participantFormData.phone,
          loyalty_card_number: this.participantFormData.loyalty_card_number,
        })
        .then(response => {
          this.$store.dispatch('setUserToken', response.data.jwt)

          return ApiService.getSession()
        })
        .then(response => {
          this.$store.dispatch('setUser', response.data)
          userEventBus.$emit('user.logged')
          this.$bvModal.hide('participantFormModal')
        })
        .finally(() => {
          this.participantFormLoading = false
          this.currentWorkshop = undefined
        })

        // @todo Add catch
      },

      backToPlacesChoice() {
        const queryParams = this.$route.query
        queryParams.pc = undefined
        queryParams.ref = undefined

        this.$store.dispatch('resetPlaceCode')

        return this.$router.push({ name: 'places.choice', query: queryParams })
      }
    },

    watch: {
      search: debounce(function(search) {
        this.fetchWorkshops(search);
      }, 500)
    }
  }
</script>
